import { useQuery } from '@tanstack/vue-query';
import { api } from '/app/plugins/services';
import { relate } from '/app/utils/relationships';
import { computed, isRef, ref, toValue } from 'vue';
import { useAuth } from '/app/composables/auth';

export const useMyStaffs = () => {
  const { auth } = useAuth();
  const isEnabled = computed(() => !!auth.user?.id);

  return useQuery({
    queryKey: ['staffs', 'available'],
    queryFn: async () => {
        const { data: response } = await api.staff.all().then(relate([
            [(c => `platform:${c.platform_id}`), 'platform'],
            [(c => `user:${c.user_id}`), 'user'],
        ]));

        return response?.data ?? [];
    },
    throwOnError: false,
    enabled: isEnabled,
  })
}

export const useUserStaffs = (userId) => {
  userId = isRef(userId) ? userId : ref(userId);
  const isEnabled = computed(() => !!userId.value)

  return useQuery({
    queryKey: ['staffs', 'user', userId, 'available'],
    queryFn: async () => {
        const { data: response } = await api.staff.fromUser(userId.value).then(relate([
            ['platform_id@id', 'platform'],
        ]));

        return response?.data ?? [];
    },
    throwOnError: false,
    enabled: isEnabled,
  })
}

export const usePlatformStaff = (platformSlug) => {
  const isEnabled = computed(() => !!toValue(platformSlug))

  return useQuery({
    queryKey: ['staffs', 'platform', platformSlug],
    queryFn: async () => {
        const { data: response } = await api.staff.fromPlatform(toValue(platformSlug)).then(relate([
            ['user_id', 'user'],
        ]));

        return response?.data ?? [];
    },
    enabled: isEnabled,
  })
}
